import styled from 'styled-components';
import { $FormElementControl } from '../newFormElement/styles';
export const $FormControl = styled($FormElementControl) ``;
